import {ReviewerRole, CreateOrUpdateReviewerRole, ReviewerRoleId} from "platformed-client/types";
import {platformedClient} from "..";
import {invalidateQueries, q} from "../../state";

export async function list(): Promise<ReviewerRole[]> {
  return platformedClient.internalRequest("get", "/region/{region}/api/tprm/reviewer_roles", {});
}

export async function create(reviewerRole: CreateOrUpdateReviewerRole): Promise<ReviewerRole> {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/tprm/reviewer_roles", {
    body: reviewerRole,
  });
  await invalidateQueries([q.tprm.reviewerRoles.filter()]);
  return res;
}

export async function update(reviewerRoleId: ReviewerRoleId, update: CreateOrUpdateReviewerRole): Promise<void> {
  await platformedClient.internalRequest("patch", "/region/{region}/api/tprm/reviewer_roles/{reviewer_role_id}", {
    path: {reviewer_role_id: reviewerRoleId},
    body: update,
  });
  await invalidateQueries([q.tprm.reviewerRoles.filter()]);
}

export async function reorder(reviewerRoleId: ReviewerRoleId, ordinal: number): Promise<void> {
  await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/reviewer_roles/{reviewer_role_id}/reorder",
    {path: {reviewer_role_id: reviewerRoleId}, body: ordinal},
  );
  await invalidateQueries([q.tprm.reviewerRoles.filter()]);
}
